import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-empty-chart',
  templateUrl: './empty-chart.component.html',
  styleUrls: ['./empty-chart.component.scss']
})
export class EmptyChartComponent implements OnInit {
  @HostBinding('class.empty') hostClass = false;
  @Input() empty: boolean;
  constructor() {}

  ngOnInit() {
    this.hostClass = this.empty;
  }
}
